<span class="badge fs-6 rounded-pill" [ngClass]="{
    'NEW': 'text-bg-primary',
    'NOT_STARTED': 'text-bg-danger',
    'IN_PROGRESS': 'text-bg-warning',
    'PENDING_APPROVAL': 'text-bg-info',
    'APPROVED': 'text-bg-success'
}[status()]">
    @switch (status()) {
    @case ('NEW') {
    Nieuw!
    }
    @case ('NOT_STARTED') {
    Nog niet gestart
    }
    @case ('IN_PROGRESS') {
    Onvoltooid
    }
    @case ('PENDING_APPROVAL') {
    Wacht op goedkeuring
    }
    @case ('APPROVED') {
    Voltooid
    }
    }
</span>
